import firebase, { db } from 'lib/firebase';
import store from 'lib/store';

const listen = () => {
  const userId = firebase.auth().currentUser.uid;
  const userRef = db.child('users').child(userId);

  const objectsToListenTo = [
    {
      dbRef: db.child('data/debts'),
      keyPath: 'debtKeys',
      actions: {
        upsert: item => store.dispatch({ type: 'UPSERT_DEBT', payload: item }),
        remove: key => store.dispatch({ type: 'REMOVE_DEBT', payload: key }),
        loaded: key => store.dispatch({ type: 'LOADED_DEBTS', payload: key }),
      },
    },
    {
      dbRef: db.child('data/settings'),
      keyPath: 'settingKeys',
      actions: {
        upsert: item => store.dispatch({ type: 'UPSERT_SETTING', payload: item }),
        remove: key => store.dispatch({ type: 'REMOVE_SETTING', payload: key }),
        loaded: key => store.dispatch({ type: 'LOADED_SETTINGS', payload: key }),
      },
    },
  ];

  class ObjectWatcher {
    constructor(ref, snapshot, type, loading) {
      this.initial = loading;
      this.type = type;
      this.key = snapshot.key;
      this.ref = ref.child(this.key);
      this.ref.on('value', this.onChange.bind(this));
    }

    onChange(snapshot) {
      if (this.initial) {
        this.initial = false;
      } else {
        if (!snapshot || !snapshot.val()) return;

        this.type.actions.upsert({
          id: snapshot.key,
          ...snapshot.val(),
        });
      }
    }

    remove() {
      this.type.actions.remove(this.key);
      this.ref.off('value', this.onChange);
    }
  }

  class ListWatcher {
    constructor() {
      this.cache = {};
      this.initialLoadComplete = {};
    }

    watchList(ref, type) {
      ref.on('child_added', snap => this.onChildAdded(ref, snap, type));
      ref.on('child_removed', snap => this.onChildRemoved(snap, type));
      ref.once('value', snap => this.onChildrenLoaded(snap, type));
    }

    onChildrenLoaded(snapshot, type) {
      type.actions.loaded(snapshot.val());
      this.initialLoadComplete[type.keyPath] = true;
    }

    onChildAdded(ref, snapshot, type) {
      this.cache[snapshot.key] = new ObjectWatcher(ref, snapshot, type, !this.initialLoadComplete[type.keyPath]);
    }

    onChildRemoved(snapshot, type) {
      this.cache[snapshot.key].remove();
      delete this.cache[snapshot.key];
    }
  }

  const listWatcher = new ListWatcher();

  objectsToListenTo.forEach(objectToListenTo => {
    listWatcher.watchList(userRef.child(objectToListenTo.keyPath), objectToListenTo);
  });
};

firebase.auth().onAuthStateChanged(user => {
  if (user) {
    store.dispatch({ type: 'USER_AUTHENTICATED', payload: user });
    listen();
  } else {
    store.dispatch({ type: 'USER_UNAUTHENTICATED', payload: user });
  }
});



// WEBPACK FOOTER //
// ./src/lib/firebase-listen.js